import { gql } from '@apollo/client';

const GET_RETURN_METHOD = gql`
  query ReturnMethods($dropoffLocationsInput: DropoffLocationsInput) {
    returnMethods(dropoffLocationsInput: $dropoffLocationsInput) {
      mapUrl
      returnMethodId
      returnMethodPreference
      name
      type
      outputDisplayType
      distributionCenterReturnAddress
      dropoffLocationsResponse {
        addressGeoCoordinates {
          latitude
          longitude
        }
        dropoffLocations {
          id
          name
          distance
          locationId
          geoPosition {
            latitude
            longitude
          }
          providerType
          operatingHours {
            dayOfWeek
            closeHours
            openHours
          }
          address {
            city
            postalCode
            state
            street
          }
        }
        postalCode
        qrcodeEnabled
        cityStateText
        findStoreText
        locationText
        youText
        noStoresFoundNearText
        pleaseTryDifferentLocationText
        locationServicesBlockedText
        headerTextKey
        subTitleTextKey
      }
      header
      headerBadge
      description
      descriptionEmphasis
      subText
      children {
        showDistributionAddress
        postalCode
        showDropoffLocations
        dropoffLocationsLink
        showMapLink
      }
      showMapLinkOnConfirmation
      eligibilityNoticeText
      purolatorQRCodeServiceDetailsText
      purolatorSearchEligibleDropOffText
      showRETNumberOnConfirmation
      smartLabel
    }
  }
`;
export default GET_RETURN_METHOD;
